import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import { chartOfAccountsSelectors } from 'app-components/flux/chart-of-accounts';
import { List } from 'immutable';

import PayeeAutocomplete from 'components/PayeeAutocomplete';
import QAmountField from 'components/QAmountField';
import MuiTagsField from 'components/QuickenControls/TagsField/TagsField';

const CashFlowTransactionForm = (props) => {
  const { formik } = props;

  const isIncome = useSelector((state) => chartOfAccountsSelectors.isIncome(state, formik.values.coa));
  const [autoSign, setAutoSign] = useState(formik.values.amount > 0 === isIncome);

  useEffect(() => {
    formik.registerField('amount', {
      validate: (value) => (typeof value === 'number' && Number(value) !== 0 ? undefined : 'use valid number'),
    });
    formik.registerField('payee', { validate: (value) => (value ? undefined : 'required') });
    return () => {
      formik.unregisterField('amount');
      formik.unregisterField('payee');
    };
  }, [formik]);

  useEffect(() => {
    // only update strict field sign on income category change
    if (autoSign) {
      const amount = (isIncome ? +1 : -1) * Math.abs(formik.values.amount);
      if (!Number.isNaN(amount) && amount !== formik.values.amount) {
        formik.setFieldValue('amount', amount);
      }
    }
  }, [isIncome]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Box display='flex' gap={2}>
        <PayeeAutocomplete
          inputValue={formik.values.payee}
          onInputChange={(event, value, _reason) => formik.setFieldValue('payee', value)}
          textFieldProps={{
            error: Boolean(formik.submitCount > 0 && formik.errors.payee),
            helperText: (formik.submitCount > 0 && formik.errors.payee) || '',
            style: { width: 240 },
            autoFocus: true,
          }}
          selectOnFocus
          openOnFocus={false}
        />
        <MuiTagsField
          id='tags'
          value={(Array.isArray(formik.values.tags) ? formik.values.tags : formik.values.tags?.toArray()) || []}
          onChange={(_e, tagArray, _reason, _details) => formik.setFieldValue('tags', List(tagArray))}
        />
      </Box>

      <QAmountField
        id='amount'
        editable
        label='Total amount'
        sx={{ minWidth: 110 }}
        expectedSign={isIncome ? 'positive' : 'negative'}
        value={formik.values.amount}
        onChange={(event) => {
          const value = Number(event.target.value);
          if (!Number.isNaN(value)) {
            setAutoSign(Math.sign(value) === (isIncome ? +1 : -1));
            formik.setFieldValue('amount', value);
          }
        }}
        error={Boolean(formik.submitCount > 0 && formik.errors.amount)}
        helperText={(formik.submitCount > 0 && formik.errors.amount) || ''}
      />
    </>
  );
};

CashFlowTransactionForm.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default CashFlowTransactionForm;
